module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header cursor-pointer flex justify-between items-center"
  }, [_c('h1', {
    staticClass: "logo"
  }, [_c('strong', [_c('a', {
    staticClass: "text-gray-700 no-underline",
    attrs: {
      "href": "/"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/')
      }
    }
  }, [_c('span', {
    staticClass: "color-logo-1"
  }, [_vm._v("best")]), _vm._v(" "), _c('span', {
    staticClass: "color-logo-2"
  }, [_vm._v("spots")])])])]), _vm._v(" "), _c('button', {
    staticClass: "bg-blue-400 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/create')
      }
    }
  }, [_vm._v("Create")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24e0711e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteHeader.vue
// module id = 156
// module chunks = 1